import { Enums } from '@flightscope/baseball-stats';

const ZONES = {
  all: Enums.StrikeZoneSectors.all.zones,
  inner: Enums.StrikeZoneSectors.inner.zones,
  outer: Enums.StrikeZoneSectors.outer.zones,
};

export default ZONES;
